import { Event } from "../Event";

export class CompanyEvents extends Event {
    public onLoad = () => {

    }
}